import { RightsholderContactTypes } from '@App/enum/rightsholder-contact-types'

export const getRightsholderContactType = (contactType: RightsholderContactTypes | null) => {
    switch (contactType) {
        case RightsholderContactTypes.PUBLIC:
            return 'Public'
        case RightsholderContactTypes.LEGAL:
            return 'Legal'
        case RightsholderContactTypes.FINANCE:
            return 'Finance'
        case RightsholderContactTypes.COPYRIGHT:
            return 'Copyright'
        case RightsholderContactTypes.MEMBER_SERVICES:
            return 'Member Support'
        default:
            return ''
    }
}
